import React from 'react';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Box from '@mui/material/Box';
import { useTheme, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { keyframes } from '@emotion/react';
import { useWhatsApp } from '../contexts/WhatsAppContext';

// Animación de pulso sutil
const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
`;

// Color verde de WhatsApp
const whatsappGreen = '#25D366';

function WhatsAppFab() {
  // Número de WhatsApp (puedes cambiarlo si es necesario)
  const phoneNumber = '59898885151';
  
  // Obtener el mensaje del contexto (si existe) o usar el mensaje genérico
  const { message } = useWhatsApp();
  
  // Detectar si estamos en la página de detalle del paquete
  const location = useLocation();
  const isPackageDetailPage = location.pathname.startsWith('/paquetes/') && 
                               location.pathname !== '/paquetes';
  
  // Detectar si estamos en móvil
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  // Ocultar en móvil cuando estamos en la página de detalle del paquete
  const shouldHide = isMobile && isPackageDetailPage;
  
  // Mensaje predefinido para mejorar la conversión (solo si no hay mensaje del contexto)
  const defaultMessage = '¡Hola! Me interesa conocer más sobre los servicios de Voybus. ¿Podrían ayudarme?';
  
  // Usar el mensaje del contexto si existe, sino el mensaje genérico
  const finalMessage = message || defaultMessage;
  const encodedMessage = encodeURIComponent(finalMessage);
  
  // URL de WhatsApp con mensaje
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  const handleClick = () => {
    // Abrir WhatsApp en nueva pestaña
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    
    // Aquí podrías agregar tracking de analytics si lo necesitas
    // Ejemplo: gtag('event', 'whatsapp_click', { ... });
  };

  // No renderizar si debemos ocultarlo
  if (shouldHide) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 1000, // Asegurar que esté por encima de otros elementos
        borderRadius: '50%', // Asegurar que el contenedor sea circular
      }}
    >
      <Tooltip
        title="¿Necesitas ayuda? Escríbenos por WhatsApp"
        placement="left"
        arrow
      >
        <Fab
          color="primary"
          aria-label="Contactar por WhatsApp"
          onClick={handleClick}
          sx={{
            backgroundColor: whatsappGreen,
            color: '#fff',
            width: 56,
            height: 56,
            borderRadius: '50%', // Asegurar forma circular
            animation: `${pulse} 2s infinite`,
            '&:hover': {
              backgroundColor: '#20BA5A', // Verde más oscuro al hover
              transform: 'scale(1.1)',
              transition: 'all 0.3s ease-in-out',
            },
            // Sombra para mejor visibilidad
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          }}
        >
          <WhatsAppIcon sx={{ fontSize: 28 }} />
        </Fab>
      </Tooltip>
    </Box>
  );
}

export default WhatsAppFab;

